module.exports = __webpack_public_path__ + "static/img/about_us_old.c21e2ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/about_us_old.png
// module id = pdH4
// module chunks = 1